// extracted by mini-css-extract-plugin
module.exports = {"shipping-leads":"ShippingLeads_shipping-leads__3E9rj"};